<div class="p-4 bottom80" id="admin-aziende">
    <h2 class="fs28 gray-dark inter bold mb-5" translate>aziende.aziende</h2>
    <div>
        <app-aziende></app-aziende>
    </div>
</div>